export const CUSTOM_SERVER_DATA_ID = '__SBIZ_CUSTOM_SERVER_DATA__';
export const MOCK_USER_AUTH_COOKIE_KEY = 'MOCK_USER_AUTH';
// GTM Container ID
export const GTM_CONTAINER_ID = 'GTM-TSVZDWK';

export const SELECTED_PRODUCT_COOKIE_NAME = 'SelectedProduct';
export const DEFERRED_EVENTS_COOKIE_NAME = '__deferred_events__';
